/** @format */

import { memo } from 'react'
import { CopyBlock, ocean } from 'react-code-blocks'

import styles from 'dir/styles/courses.module.css'

export const _5 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>5 - Радиокнопки</h2>
    <p className={styles.description}>
      В отличии от привычной группировки по значению атрибута <code className={styles.code}>name</code>, в React
      радиокнопка это всего лишь элемент интерфейса, который:{' '}
    </p>
    <ul className={styles.list}>
      <li className={styles.list__item}>Знает выбран ли он </li>
      <li className={styles.list__item}>Может попросить форму изменить выделение </li>
    </ul>
    <p className={styles.description}>
      Обычно у радиокнопок есть и атрибут <code className={styles.code}>checked</code> и{' '}
      <code className={styles.code}>value</code>. К примеру радио кнопка отвечающая за выбор пола пользователя.{' '}
    </p>
    <CopyBlock
      text={`<input
  type="radio"
  checked={this.state.gender === 'male'}
  value="male"
  onChage={this.handleGenderChange}
/>`}
      language="javascript"
      showLineNumbers={false}
      theme={ocean}
    />
    <p className={styles.description}>Добавим группу радиокнопок в нашу форму. </p>
    <CopyBlock
      text={`/*
 * Используем Enumerable чтобы не болеть антипаттерном "магические числа"
 */
const Gender = {
  MALE: 'male',
  FEMALE: 'female',
};

const INITIAL_STATE = {
  login: '',
  email: '',
  password: '',
  agreed: false,
  gender: null,
};

class SignUpForm extends React.Component {
  state = {
    ...INITIAL_STATE,
  };

  /*... */

  render() {
    const { login, email, password, agreed, gender } = this.state;

    return (
      <form onSubmit={this.handleSubmit}>
        {/* ... */}

        <section>
          <h2>Choose your gender</h2>
          <label>
            Male
            <input
              type="radio"
              checked={gender === Gender.MALE}
              name="gender"
              value={Gender.MALE}
              onChange={this.handleChange}
            />
          </label>
          <label>
            Female
            <input
              type="radio"
              checked={gender === Gender.FEMALE}
              name="gender"
              value={Gender.FEMALE}
              onChange={this.handleChange}
            />
          </label>
        </section>

        <button type="submit" disabled={!agreed}>
          Sign up as {login}
        </button>
      </form>
    );
  }
}`}
      language="javascript"
      showLineNumbers={false}
      theme={ocean}
    />
  </section>
))
